import React from 'react'
import { withStyles, Typography, TextField } from '@material-ui/core'

const styles = theme => ({
    subHeader: {
        color: '#878787',
        flex: 1
    },
    containerLabelsFullWidth: {
        display: 'flex'
    },
    formFields: {
        display: 'inline',
        margin: '0 0 10px 0px',
        height: '45px',
        marginBottom: '7px',
        marginTop: '7px',
    },
})

const ReactTextField = (props) => {
    let { classes, label, value, valueString, changeHandler, multiline = false, rows = 0, inputLength = 0, placeholder,  ...other } = props

    return (
        <React.Fragment>
            <div className={[classes.containerLabelsFullWidth, props.labelClass].join(' ')}>
                <Typography className={[props.subHeaderClass, classes.subHeader].join(' ')} color="textSecondary">{label}</Typography>
            </div>
            <TextField
                {...other}
                variant="outlined"
                className={[props.fieldClass, classes.formFields].join(' ')}
                placeholder={placeholder}
                value={value}
                onChange={(event) => changeHandler(valueString, event.target.value)}
                fullWidth
                multiline={multiline}
                rows={rows}
                margin="normal"
                InputLabelProps={{
                    'aria-label': 'Name',
                }}
                inputProps={{
                    maxLength: inputLength
                }}
            />
        </ React.Fragment>
    )
}

export default withStyles(styles)(ReactTextField)